import { render, staticRenderFns } from "./List-Review.vue?vue&type=template&id=ab985c5a"
import script from "./List-Review.vue?vue&type=script&lang=js"
export * from "./List-Review.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./List-Review.vue?vue&type=style&index=1&id=ab985c5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports